import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'

const ContingenciaGestion = lazy(() => import('./view/ContingenciaGestion'))

export const contingenciaRoutesMap = {
  gestion: {
    path: '/contingencia/gestion',
    name: 'Gestion de Contingencias',
    actioneSecure: 'Registrar Contingencia',
  },
  historial: {
    path: '/contingencia/historial',
    name: 'Historial de Contingencias',
  },
  registro: {
    path: '/contingencia/registro',
    name: 'Registro de Contingencia',
  },
}
/**
 * Contingencia
 */
const contingenciaRoutes = [
  {
    path: contingenciaRoutesMap.gestion.path,
    element: <ContingenciaGestion />,
    auth: authRoles.admin,
  },
]
export default contingenciaRoutes
